import { CommonModule } from '@angular/common';
import {
  Component,
  signal,
  output,
  computed,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { VIDEO_HERO_PRESETS } from '../../../../../../shared/constants/video-hero-presets.constants';

@Component({
  selector: 'app-video-heroes-settings',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './video-heroes-settings.component.html',
  styleUrl: './video-heroes-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoHeroesSettingsComponent implements OnInit {
  readonly presets = VIDEO_HERO_PRESETS;

  selectedMainName = signal<string>(VIDEO_HERO_PRESETS[0]?.name ?? '');
  /** Hero names selected as background (never includes main). */
  private backgroundNames = signal<Set<string>>(new Set());

  dataChange = output<{
    videoMainHeroName: string;
    videoMainHeroDescription: string;
    videoBackgroundHeroNames: string[];
  }>();

  private payload = computed(() => {
    const main = this.selectedMainName();
    const bg = [...this.backgroundNames()].filter((n) => n !== main);
    return {
      videoMainHeroName: main,
      videoMainHeroDescription: '',
      videoBackgroundHeroNames: bg,
    };
  });

  isBackgroundChecked(name: string): boolean {
    return this.backgroundNames().has(name);
  }

  isMain(name: string): boolean {
    return this.selectedMainName() === name;
  }

  selectMain(name: string): void {
    this.selectedMainName.set(name);
    if (this.backgroundNames().has(name)) {
      const next = new Set(this.backgroundNames());
      next.delete(name);
      this.backgroundNames.set(next);
    }
    this.emit();
  }

  toggleBackground(name: string): void {
    if (this.isMain(name)) return;
    const next = new Set(this.backgroundNames());
    if (next.has(name)) next.delete(name);
    else next.add(name);
    this.backgroundNames.set(next);
    this.emit();
  }

  ngOnInit(): void {
    this.emit();
  }

  private emit(): void {
    this.dataChange.emit(this.payload());
  }
}
